import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, map } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { BasicStatItem } from 'src/app/shared/interfaces/statistics/stat-basic-item.interface'
import { StatCounter } from 'src/app/shared/interfaces/statistics/stat-counter.interface'
import { StatGroupCounter } from 'src/app/shared/interfaces/statistics/stat-group-counter.interface'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class StatisticsService {
    constructor(private httpclient: HttpClient) {}

    getCustomerStatistics(): Observable<StatCounter[]> {
        return this.httpclient
            .get<ApiResponse<StatCounter[]>>(`${environment.baseUrl}Statistics/Customer/Count`)
            .pipe(map((x) => x.result))
    }

    getCustomerByMarketSources(): Observable<StatGroupCounter[]> {
        return this.httpclient
            .get<ApiResponse<StatGroupCounter[]>>(`${environment.baseUrl}Statistics/Customer/MarketSources/Count`)
            .pipe(map((x) => x.result))
    }

    getAppointmentStatistics(): Observable<StatCounter[]> {
        return this.httpclient
            .get<ApiResponse<StatCounter[]>>(`${environment.baseUrl}Statistics/Appointment/Count`)
            .pipe(map((x) => x.result))
    }

    getBaseStatistics(): Observable<BasicStatItem[]> {
        return this.httpclient
            .get<ApiResponse<BasicStatItem[]>>(`${environment.baseUrl}Statistics/BaseStats`)
            .pipe(map((x) => x.result))
    }
}
